export default __webpack_public_path__ + "static/media/005-watching movies.b8da1c9a.png";